<mat-card class="card-login  mat-elevation-z5">
  <mat-card-title>
    <div class="flex-center" style="margin-top: 20px;">
      File-Archiv
    </div>
  </mat-card-title>
  <div  style="margin-top: 50px">

    <mat-chip-listbox [multiple]="true">
      <mat-chip-option

        (click)="checkAlle('Alle')"
        [selected]="FileSelect['Alle']"
        >
        Alle
      </mat-chip-option>

      <mat-chip-option
        (click)="checkAlle('Adressen')"
        [selected]="FileSelect.Adressen">
        Adressen
      </mat-chip-option>

      <mat-chip-option
        (click)="checkAlle('Antrag')"
        [selected]="FileSelect.Antrag">
        Anhang Antrag
      </mat-chip-option>

      <mat-chip-option
        (click)="checkAlle('Schadenfall')"
        [selected]="FileSelect.Schadenfall">
        Anhang Schadenfall
      </mat-chip-option>

      <mat-chip-option
        (click)="checkAlle('Transportversicherung');"
        [selected]="FileSelect.Transportversicherung">
        Transportversicherung
      </mat-chip-option>

      <mat-chip-option
        (click)="checkAlle('Pferdestatistik');"
        [selected]="FileSelect.Pferdestatistik">
        Pferdestatistik
      </mat-chip-option>


    </mat-chip-listbox>

    <mat-chip-listbox >
      <mat-chip-option
        (click)="checkAlle('Jahr')"
        [selected]="FileSelect.Jahr">
        nur dieses Jahr
      </mat-chip-option>

      <mat-chip-option
        (click)="checkAlle('lJahr');"
        [selected]="FileSelect.lJahr">
        nur letztes Jahr
      </mat-chip-option>

    </mat-chip-listbox>


    @if (fileList!=undefined) {
      <div >
        <table style="width:100%; margin-top: 20px; cursor: default;" >
          @for (f of fileList; track f) {
            <tr (click)="getFile(f.FileID, f.FileName)"   >
              <th [ngClass]="{'rowGray': 0 === idx % 2}" ng-class="{waiting: globserv.runstatus=='running'}" class= "tabContentLeft1">{{f.TimeStamp}}</th>
              <th class= "tabContentLeft2">{{f.FileName}}</th>
              <th style="cursor: pointer;"> <mat-icon aria-hidden="false" aria-label="downoad File">save_alt</mat-icon></th>
            </tr>
          }
          <tr>
          </table>
        </div>
      }
    </div>
  </mat-card>
